import { createContext } from 'react';

type AvailabilityDayButtonContextValue = {
    readonly availabilityCountByDate: Map<string, number>;
    readonly formatAppointmentCount: (count: number) => string;
};

export const AvailabilityDayButtonContext = createContext<AvailabilityDayButtonContextValue>({
    availabilityCountByDate: new Map(),
    formatAppointmentCount: count => `${count}`,
});
